import ReactHabitat from "react-habitat";
import { ReduxDomFactory } from "react-habitat-redux";
import configureStore from "stores";
import rootSaga from "sagas";
import { appInitialize } from "actions";
import { getRegistrationMap } from "utils/component";
import config from "config";

class App extends ReactHabitat.Bootstrapper {
  constructor() {
    super();
    const initialState = config.state ? config.state : {};
    const store = configureStore(initialState);
    const containerBuilder = new ReactHabitat.ContainerBuilder();

    containerBuilder.factory = new ReduxDomFactory(store);

    // Some strange eslint behaviour, does not detect usage of variables
    for (let [name, comp] of getRegistrationMap()) {
      containerBuilder.register(comp).as(name);
    }

    this.setContainer(containerBuilder.build());

    store.runSaga(rootSaga);
    store.dispatch(appInitialize(global.location.search));
  }
}

export default new App();
